export default __webpack_public_path__ + "static/media/bandeira_us.ae1e31b6.png";